import VyjadreniaPredbeznaInformacia from './VyjadreniaPredbeznaInformacia';

export default VyjadreniaPredbeznaInformacia;
